var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBagWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35816 0.164276C3.82791 -0.130309 3.74444 0.28702 3.76899 0.532508C3.76899 2.62407 5.24191 3.71158 5.97837 3.99388H7.04625C9.46185 4.31793 10.1639 1.82132 10.213 0.532508C10.272 -0.05666 9.60149 -0.121168 9.40293 0.164276C8.95728 0.652119 8.51162 0.836242 7.99987 0.532508C7.4107 -0.115577 6.29751 0.262473 5.97837 0.532508C5.21245 0.827094 4.5791 0.409764 4.35816 0.164276Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09535 3.38672C3.32784 4.56506 0.244902 7.01012 0.00923406 11.4878C-0.0398635 12.3716 0.00923248 15.3174 2.73415 15.9802H9.66142C10.9871 16.1275 13.7075 15.3469 14.0021 12.2243C14.0757 10.4077 13.4865 6.25893 9.1459 3.38672H5.09535ZM10.0988 14.9466C11.0562 14.922 12.8974 14.1659 12.6028 11.3379C12.2345 12.3444 11.2182 14.4752 10.0988 14.9466Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90393 1.47266C4.78056 1.92031 4.92508 2.98891 6.49012 3.68205C5.96139 3.16219 4.90393 1.99251 4.90393 1.47266Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10736 1.47266C9.23073 1.92031 9.08621 2.98891 7.52117 3.68205C8.0499 3.16219 9.10736 1.99251 9.10736 1.47266Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78471 3.4634C6.87063 3.16881 6.99092 2.41762 6.78471 1.76953C7.09157 2.19914 7.52117 3.13935 6.78471 3.4634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagWhite);
export default __webpack_public_path__ + "static/media/bag-white.06c043060fd2baf72be603fe0c526e2b.svg";
export { ForwardRef as ReactComponent };